import AppHeaderNoauth from '../AppHeaderNoauth'
export default {
  name: 'login',
  data: function () {
    return {
      loginId: '',
      password: '',
      keepLogin: false,
      app_type: 'asovi'
    }
  },
  created: function () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
    if (window.localStorage.getItem('access_token')) {
      this.authorize()
    }
  },
  computed: {
    error () {
      return this.$store.getters.authError || this.$store.getters.apiError
    }
  },
  components: {
    AppHeaderNoauth
  },
  methods: {
    login: function () {
      var formData = new FormData();
      formData.append('user[login_id]', this.loginId);
      formData.append('user[password]', this.password);
      formData.append('app_type', this.app_type);
      this.$store.dispatch('LOGIN', {data: formData, keepLogin: this.keepLogin, callback: this.loginSuccess})
    },
    border: function () {
      if (this.$store.getters.authError || this.$store.getters.apiError) {
        return 'border: thin solid #dd6f60;'
      }
    },
    loginSuccess: function () {
      var button = document.getElementById('helpModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goTop: function () {
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect)
        return
      }
      this.$router.push({ path: '/' })
    },
    authorize: function () {
      this.$store.dispatch('AUTHORIZE', {callback: this.authOk})
    },
    authOk: function (result) {
      this.$router.push('/')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/login.js